import React from 'react'
import { getGif } from 'app/records/team'

export default function TeamGif ({ team, short }) {
  let className = 'gif-picker__gif'

  if (short) {
    className += ' gif-picker__gif--short'
  }

  return (
    <div className={ className } style={{ backgroundImage: `url(${ getGif(team) })` }} />
  )
}



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/team-gif.jsx
 **/